const api = {
  // 扫码点单
  guestScan: '/api16931/PROD/guest/scan', // 扫码点单(根据Mac获取房台信息和授权token)
  ping: '/api16931/PROD/ping', // 延长token的有效期
  frontRoomOpenPack: '/api16931/PROD/front/room/openPack', // 获取开房套餐
  frontFoodTypeList: '/api16931/PROD/front/foodType/list', // 菜品类别列表
  frontFoodItemList: '/api16931/PROD/front/foodItem/list', // 菜品列表
  frontPrintRequire: '/api16931/PROD/front/printRequire', // 出品要求
  frontPackItemList: '/api16931/PROD/front/packItem/list2', // 套餐子项目列表
  // 点选花单
  frontFlowerDepartment: '/api16931/PROD/front/flower/department', // 可接受花旦部门
  guestPerformer: '/api16931/PROD/guest/performer', // 花单点跳列表
  // 立即落单
  systemSysparaList: '/api16931/PROD/system/syspara/list', // 获取系统参数
  frontOrderConfirmInput: '/api16931/PROD/front/order/confirm/input', // 立即落单
  // 立即支付
  guestConfirmInput: '/api16931/PROD/guest/confirm/input', // 客人确认落单并支付
  // 账单
  frontBill: '/api16931/PROD/front/bill', // 消费明细
  frontSummaryBill: '/api16931/PROD/front/summary/bill', // 消费汇总
  frontRoundsList: '/api16931/PROD/front/rounds/list', // 巡房记录
  frontDutyList: '/api16931/PROD/front/duty/list', // 值台记录
  liTongAccessToken: '/litong/api/v1/oauth2/token',
  liTongvodStoreInfo: '/litong/api/v1/ts/aws-base-info/get', // 门店信息
  liTongvodStoreFoodType: '/litong/api/v1/ts/goods-combo/category/query', // 立通商品种类
  liTongvodStoreFoods: '/litong/api/v1/ts/goods-combo/query', // 立通商品
  liTongCreateOrder: '/litong/api/v1/ts/order/create', // 商品预下单
}
export default {
  api,
  domain: 'https://login.16931.com/PROD',
}
